module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-12.30ef312e.jpg";